module.exports = __webpack_public_path__ + "img/img3.03b041c0.jpg";